// extracted by mini-css-extract-plugin
module.exports = {"grid":"Grid_grid__8e_U7"};